import React from 'react';
import { AlertTriangleIcon, AnchorIcon, BoxesIcon, FileWarningIcon, ShipIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
const metrics = [{
  label: 'Active vessels',
  value: '248',
  note: '231 underway',
  Icon: ShipIcon,
  tone: 'cyan'
}, {
  label: 'Containers at risk',
  value: '1,284',
  note: '↑ 8.4% / 24h',
  Icon: BoxesIcon,
  tone: 'red'
}, {
  label: 'Customs holds',
  value: '27',
  note: '3 over SLA',
  Icon: FileWarningIcon,
  tone: 'amber'
}, {
  label: 'Congested ports',
  value: '06',
  note: '2 critical',
  Icon: AnchorIcon,
  tone: 'amber'
}, {
  label: 'Priority shipments',
  value: '142',
  note: '96.2% on plan',
  Icon: AlertTriangleIcon,
  tone: 'lime'
}] as const;
const toneStyles = {
  cyan: 'text-cyan-300 border-cyan-400/20',
  red: 'text-red-300 border-red-400/25',
  amber: 'text-amber-300 border-amber-400/25',
  lime: 'text-lime-300 border-lime-400/20'
};
export function KpiRail() {
  const reduceMotion = useReducedMotion();
  return <section aria-label="Network status metrics" className="grid border-b border-slate-700/70 bg-[#08121b] sm:grid-cols-2 lg:grid-cols-5" data-id="element-43">
      {metrics.map(({
      label,
      value,
      note,
      Icon,
      tone
    }, index) => <motion.article key={label} initial={reduceMotion ? false : {
      opacity: 0,
      y: -6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.25,
      delay: index * 0.045
    }} className={`relative flex min-h-20 items-center gap-3 border-b border-r p-3 last:border-r-0 sm:p-4 lg:border-b-0 ${toneStyles[tone]}`} data-id="element-44">
          <Icon className="h-5 w-5 shrink-0 opacity-80" aria-hidden="true" data-id="element-45" />
          <div className="min-w-0" data-id="element-46">
            <p className="truncate font-mono text-[9px] uppercase tracking-[0.14em] text-slate-500" data-id="element-47">
              {label}
            </p>
            <div className="mt-0.5 flex items-baseline gap-2" data-id="element-48">
              <strong className="font-mono text-xl font-semibold tabular-nums text-slate-100" data-id="element-49">
                {value}
              </strong>
              <span className={`text-[9px] ${toneStyles[tone].split(' ')[0]}`} data-id="element-50">
                {note}
              </span>
            </div>
          </div>
          <span className={`absolute right-2 top-2 h-1 w-1 rounded-full ${tone === 'red' ? 'bg-red-400' : tone === 'amber' ? 'bg-amber-400' : tone === 'lime' ? 'bg-lime-400' : 'bg-cyan-400'}`} data-id="element-51" />
        </motion.article>)}
    </section>;
}